__turbopack_context__.v({
  "className": "noto_sans_arabic_58170168-module__P9PToW__className",
  "variable": "noto_sans_arabic_58170168-module__P9PToW__variable",
});
